import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import ContentLoader from 'react-content-loader';

const Table = () => {
  const themeContext = useContext(ThemeContext);

  return (
    <ContentLoader
      style={{ padding: '0.5rem' }}
      backgroundColor={themeContext?.loadingTableColor}
      foregroundColor={themeContext?.loadingTableColorLight}
      primaryopacity={1}
      secondaryopacity={0.6}
      width="100%"
      height="95%"
      preserveAspectRatio="xMinYMin"
    >
      {Array(10)
        .fill('')
        .map((e, i) => (
          <React.Fragment key={i}>
            <rect
              key={i}
              x="10"
              y={50 * (i + 1)}
              rx="5"
              ry="5"
              width="100"
              height="10"
            />
            <rect
              x="150"
              y={50 * (i + 1)}
              rx="5"
              ry="5"
              width={`${Math.random() * (1 - 30) + 50}%`}
              height="10"
            />
            <rect
              x="80%"
              y={50 * (i + 1) - 15}
              rx="5"
              ry="5"
              width="150"
              height="30"
            />
          </React.Fragment>
        ))}
    </ContentLoader>
  );
};

export default Table;
